import React from 'react';
import PropTypes from 'prop-types';
import ReactGA from 'react-ga';

import './update-profile.scss';

import UpdateProfilePanelComponent from '../../../components/profile/Profile/UpdateProfilePanelComponent';

class UpdateProfileComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            activeKey: this.props.activePanel,
        };
    }

    handleSelect = (activeKey) => {
        this.setState({ activeKey });
    }

    componentDidMount() {
        ReactGA.set({ page: window.location.pathname });
        ReactGA.set({ title: 'Update Profile Page' });
        ReactGA.pageview(window.location.pathname);
    }

    render() {
        const {
            currentUserInfo,
        } = this.props;
        const {
            activeKey,
        } = this.state;
        return <div>
            <div className="update-profile-component">
                <h3>Profile</h3>
                <div>
                    <UpdateProfilePanelComponent
                        activeKey={activeKey}
                        handleSelect={this.handleSelect}
                        currentUserInfo={currentUserInfo}
                    />
                </div>
            </div>
        </div>;
    }
};

UpdateProfileComponent.propTypes = {
    activePanel: PropTypes.string,
    currentUserInfo: PropTypes.object,
};

export default UpdateProfileComponent;



// WEBPACK FOOTER //
// ./src/components/profile/Profile/UpdateProfileComponent.js